import { useState } from "react";
import { Save, X } from "lucide-react";

import { api, apiError } from "@/lib/api";

export default function ClientEditModal({ client, onClose, onSaved }) {
  const [form, setForm] = useState({
    nombre: client.nombre,
    ci: client.ci,
    celular: client.celular,
    correo: client.correo || "",
    ciudad: client.ciudad || "",
    observaciones: client.observaciones || "",
  });
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  const change = (event) => {
    setForm((current) => ({ ...current, [event.target.name]: event.target.value }));
  };

  const save = async (event) => {
    event.preventDefault();
    setSaving(true);
    setMessage("");
    try {
      const response = await api.put(`/clients/${client.id}`, {
        ...form,
        correo: form.correo || null,
      });
      onSaved(response.data);
    } catch (error) {
      setMessage(apiError(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="user-edit-modal" data-testid="client-edit-modal">
      <form className="user-edit-form" data-testid="client-edit-form" onSubmit={save}>
        <button
          aria-label="Cerrar edición de cliente"
          className="icon-button modal-close"
          data-testid="close-client-edit-button"
          onClick={onClose}
          type="button"
        >
          <X size={18} />
        </button>
        <span className="eyebrow">EDITAR CLIENTE</span>
        <h2>{client.nombre}</h2>
        <label htmlFor="edit-client-name">Nombre completo</label>
        <input
          data-testid="edit-client-name-input"
          id="edit-client-name"
          name="nombre"
          onChange={change}
          required
          value={form.nombre}
        />
        <div className="form-two-columns">
          <div>
            <label htmlFor="edit-client-ci">CI</label>
            <input
              data-testid="edit-client-ci-input"
              id="edit-client-ci"
              name="ci"
              onChange={change}
              required
              value={form.ci}
            />
          </div>
          <div>
            <label htmlFor="edit-client-phone">Celular</label>
            <input
              data-testid="edit-client-phone-input"
              id="edit-client-phone"
              name="celular"
              onChange={change}
              required
              value={form.celular}
            />
          </div>
        </div>
        <label htmlFor="edit-client-email">Correo</label>
        <input
          data-testid="edit-client-email-input"
          id="edit-client-email"
          name="correo"
          onChange={change}
          type="email"
          value={form.correo}
        />
        <label htmlFor="edit-client-city">Ciudad</label>
        <input
          data-testid="edit-client-city-input"
          id="edit-client-city"
          name="ciudad"
          onChange={change}
          value={form.ciudad}
        />
        <label htmlFor="edit-client-notes">Observaciones</label>
        <textarea
          data-testid="edit-client-notes-input"
          id="edit-client-notes"
          name="observaciones"
          onChange={change}
          value={form.observaciones}
        />
        {message && <p className="form-error" data-testid="client-edit-error">{message}</p>}
        <button
          className="primary-button"
          data-testid="save-client-edit-button"
          disabled={saving}
          type="submit"
        >
          <Save size={16} />
          {saving ? "Guardando..." : "Guardar cambios"}
        </button>
      </form>
    </div>
  );
}